
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import CountrySwitcherModal from '@/components/buybox/country-switcher/CountrySwitcherModal.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import BasicButton from '@/ui-components/BasicButton.vue';

import { formattedReleaseDate } from '@/helpers/date-helper';

import { Package, UpcomingReleaseLabel } from '@/@types/graphql-types';
import { ModalHelper } from '@/helpers/modal-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

const Constant = namespace('constant');
const Language = namespace('language');

@Component({
	name: 'UpcomingBox',
	components: {
		BasicButton,
		ProviderIcon,
	},
})
export default class UpcomingBox extends Vue {
	@Prop({ default: false }) isInWatchlist: boolean;
	@Prop({ required: true }) release: {
		releaseDate: string;
		label: UpcomingReleaseLabel;
		package: {
			packageId: number;
		} | null;
	};

	@Constant.Getter allProvidersById: Record<string, Package>;

	@Language.Getter countryEmoji: string;
	@Language.Getter language: string;

	get formattedReleaseDate() {
		return formattedReleaseDate(this.release.releaseDate, this.release.label, this.language, 'long');
	}

	get releaseCounterClass() {
		return this.formattedReleaseDate ? 'upcoming-box__title-info--countdown' : 'upcoming-box__title-info--no-date';
	}

	get showProviderIcon() {
		const id = this.release.package?.packageId;
		return !!id && id !== 0 && id in this.allProvidersById;
	}

	@Emit('onNotifyMe')
	onNotifyMe() {}

	openCountrySwitcherModal() {
		ModalHelper.openModal(CountrySwitcherModal, { closable: true });
		TrackingHelper.trackEvent('userinteraction', {
			action: 'country_selector_clicked',
		});
	}
}
